var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAfterAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_modify_active"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM3.88716 8.88521C2.7396 7.73764 2.56023 5.98852 3.34905 4.6529L5.39717 6.70103L6.62857 5.46963L4.58045 3.42151C5.91606 2.63268 7.66519 2.81205 8.81275 3.95962C9.88507 5.03193 10.112 6.6295 9.49354 7.92414L12.9174 11.348L11.2755 12.9899L7.85168 9.566C6.55705 10.1845 4.95948 9.95752 3.88716 8.88521Z",
    fill: "#FFB400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAfterAction);
export default __webpack_public_path__ + "static/media/icon-after-action.bb19b84717696cec66de91a4a55c29ee.svg";
export { ForwardRef as ReactComponent };